import { render, staticRenderFns } from "./AxProjectFileUpload.vue?vue&type=template&id=051a3bde&"
import script from "./AxProjectFileUpload.vue?vue&type=script&lang=ts&"
export * from "./AxProjectFileUpload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports